// Pure pointer-position -> tilt-angle math shared by every "physical card"
// touchpoint (Hero's fan, CardShowcase, and — via the same constants — the
// 3D book's hover tilt). See
// docs/superpowers/specs/2026-08-25-home-threejs-synergy-design.md §3.
function clamp(v, min, max) {
  return Math.min(max, Math.max(min, v));
}

export function computeTilt(pointerX, pointerY, rect, maxAngle) {
  const relX = clamp((pointerX - rect.left) / rect.width, 0, 1); // 0..1
  const relY = clamp((pointerY - rect.top) / rect.height, 0, 1);
  const rotateY = clamp((relX - 0.5) * 2 * maxAngle, -maxAngle, maxAngle);
  const rotateX = clamp((relY - 0.5) * 2 * maxAngle, -maxAngle, maxAngle);
  return { rotateX, rotateY, sheenX: relX * 100, sheenY: relY * 100 };
}
